import { Injectable, InjectionToken } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AppStorageService } from './app-storage.service';
export interface CheckboxState {
  checked: boolean;
}

export const CHECKBOX_SERVICE_TOKEN = new InjectionToken<CheckboxService>('MoreFiltersCustomOptions');
@Injectable({
  providedIn: 'root',
})
export class CheckboxService {
  private readonly storageKey = 'checkboxState';
  private checkboxStateSubject: BehaviorSubject<CheckboxState>;

  constructor(private appStorageService: AppStorageService) {
    this.initializeCheckboxState();
  }

  private initializeCheckboxState(): void {
    const savedState = this.appStorageService.getItem<CheckboxState>(this.storageKey);
    const initialState: CheckboxState = savedState ?? { checked: false };
    this.checkboxStateSubject = new BehaviorSubject<CheckboxState>(initialState);
  }

  getCheckboxState(): Observable<CheckboxState> {
    return this.checkboxStateSubject.asObservable();
  }

  setCheckboxState(state: CheckboxState): void {
    this.appStorageService.setItem(this.storageKey, state);
    this.checkboxStateSubject.next(state);
  }
}
